import { Text } from '@cinch-labs/design-system'
import { StaticImageData } from 'next/legacy/image'
import { useEffect, useState } from 'react'

import keyDatesCards from './assets/key-dates-cards.png'
import { getAppStoreUrl } from './get-app-store-url'
import styles from './key-dates-promo.module.css'

const keyDatesCardsImage = keyDatesCards as unknown as StaticImageData

export const KeyDatesPromo = () => {
  const [appStoreUrl, setAppStoreUrl] = useState(() => getAppStoreUrl())

  useEffect(() => {
    setAppStoreUrl(getAppStoreUrl(window.navigator.userAgent))
  }, [])

  return (
    <aside className={styles.container} data-testid="key-dates-promo">
      <div className={styles.content}>
        <Text
          element="h2"
          className={styles.heading}
          color="pureWhite"
          fontSizeFixed="l"
          fontWeight="bold"
          lineHeight="display"
        >
          Stay road-ready
        </Text>
        <Text
          element="p"
          className={styles.subheading}
          color="pureWhite"
          fontSizeFixed="s"
          fontWeight="semibold"
        >
          Keep on top of your car’s schedule and important dates
        </Text>
        <a
          className={styles.cta}
          href={appStoreUrl}
          target="_blank"
          rel="noopener noreferrer"
        >
          <Text
            element="span"
            color="deepPurple"
            fontSizeFixed="xs"
            fontWeight="semibold"
          >
            Get the cinch app
          </Text>
        </a>
      </div>
      <div className={styles.imageWrapper}>
        <img
          className={styles.image}
          src={keyDatesCardsImage.src}
          alt="Illustration of car schedule key dates for road tax, service and MOT"
          width={keyDatesCardsImage.width}
          height={keyDatesCardsImage.height}
        />
      </div>
    </aside>
  )
}
